import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DEFAULT_SUPPORTED_CHAINS } from '../../../constants';
import { subscribeToProviderEvents } from '../../../helpers';
import { Event } from '../../../helpers/event';
import { getAddNetworkParams } from '../../../helpers/getAddNetworkParams';
import { validateArguments } from '../../../helpers/validateArgument';
import { DEFAULT_CONFIG } from '../../../model/config/default';
import { MetamaskConnector } from './implementations';
export var ConnectorController = /*#__PURE__*/function () {
  function ConnectorController(connector) {
    var _this = this;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CONFIG;
    _classCallCheck(this, ConnectorController);
    this.connector = connector;
    this.updated = new Event();
    this.newBlock = new Event();
    this.active = false;
    this.accounts = [];
    this.errors = [];
    this._config = Object.assign({}, config);
    this._connectorUnsubscribe = connector.update.on(function (_ref) {
      var chainId = _ref.chainId,
        accounts = _ref.accounts;
      _this.chainId = chainId;
      _this.accounts = accounts;
      _this.emitUpdate();
    });
  }
  _createClass(ConnectorController, [{
    key: "emitUpdate",
    value: function emitUpdate() {
      this.updated.emit({
        active: this.active,
        chainId: this.chainId,
        accounts: this.accounts,
        blockNumber: this.blockNumber,
        errors: this.errors
      });
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      this._config = Object.assign(Object.assign({}, this._config), config);
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return this.connector.provider;
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var connectorActivator,
          provider,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              connectorActivator = _args.length > 0 && _args[0] !== undefined ? _args[0] : function (connector) {
                return connector.activate();
              };
              _context.next = 3;
              return connectorActivator(this.connector);
            case 3:
              provider = this.getProvider();
              if (provider) {
                _context.next = 6;
                break;
              }
              throw new Error('Failed to activate connector');
            case 6:
              this.clearSubscriptions = subscribeToProviderEvents(this.connector, function (_ref2) {
                var chainId = _ref2.chainId,
                  accounts = _ref2.accounts;
                if (chainId !== undefined) {
                  _this2.chainId = chainId;
                }
                if (accounts !== undefined) {
                  _this2.accounts = accounts;
                }
                _this2.emitUpdate();
              }, function () {
                if (_this2.connector instanceof MetamaskConnector && _this2._config.noMetamaskDeactivate) {
                  return;
                }
                void _this2.deactivate();
              });
              _context.next = 9;
              return provider.getBlockNumber();
            case 9:
              this.blockNumber = _context.sent;
              this.newBlock.emit(this.blockNumber);
              this.removeBlockEffect = this.newBlock.addEffect(function () {
                var listener = function listener(blockNumber) {
                  _this2.blockNumber = blockNumber;
                  _this2.newBlock.emit(blockNumber);
                  _this2.emitUpdate();
                };
                provider.on('block', listener);
                return function () {
                  provider.off('block', listener);
                };
              });
              this.active = true;
              this.emitUpdate();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "deactivate",
    value: function () {
      var _deactivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _a, _b, _c;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.active = false;
              (_a = this.removeBlockEffect) === null || _a === void 0 ? void 0 : _a.call(this);
              (_b = this.clearSubscriptions) === null || _b === void 0 ? void 0 : _b.call(this);
              (_c = this._connectorUnsubscribe) === null || _c === void 0 ? void 0 : _c.call(this);
              _context2.next = 6;
              return this.connector.deactivate();
            case 6:
              this.chainId = undefined;
              this.accounts = [];
              this.blockNumber = undefined;
              this.errors = [];
              this.emitUpdate();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function deactivate() {
        return _deactivate.apply(this, arguments);
      }
      return deactivate;
    }()
  }, {
    key: "switchNetwork",
    value: function () {
      var _switchNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(chainId) {
        var _a, provider, errChainNotAddedYet, chain;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              provider = this.getProvider();
              validateArguments({
                chainId: chainId
              }, {
                chainId: 'number'
              });
              if (provider) {
                _context3.next = 4;
                break;
              }
              throw new Error('Connector not initialized');
            case 4:
              _context3.prev = 4;
              _context3.next = 7;
              return provider.send('wallet_switchEthereumChain', [{
                chainId: "0x".concat(chainId.toString(16))
              }]);
            case 7:
              _context3.next = 23;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](4);
              errChainNotAddedYet = 4902; // Metamask error code
              if (!(_context3.t0.code === errChainNotAddedYet)) {
                _context3.next = 22;
                break;
              }
              chain = ((_a = this._config.networks) !== null && _a !== void 0 ? _a : DEFAULT_SUPPORTED_CHAINS).find(function (chain) {
                return chain.chainId === chainId;
              });
              if (chain) {
                _context3.next = 16;
                break;
              }
              throw new Error("ChainId \"".concat(chainId, "\" not found in config.networks. See https://usedapp-docs.netlify.app/docs/Guides/Transactions/Switching%20Networks"));
            case 16:
              if (chain.rpcUrl) {
                _context3.next = 18;
                break;
              }
              throw new Error("ChainId \"".concat(chainId, "\" does not have RPC url configured by default. See https://usedapp-docs.netlify.app/docs/Guides/Transactions/Switching%20Networks"));
            case 18:
              _context3.next = 20;
              return provider.send('wallet_addEthereumChain', [getAddNetworkParams(chain)]);
            case 20:
              _context3.next = 23;
              break;
            case 22:
              throw _context3.t0;
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 9]]);
      }));
      function switchNetwork(_x) {
        return _switchNetwork.apply(this, arguments);
      }
      return switchNetwork;
    }()
  }, {
    key: "reportError",
    value: function reportError(error) {
      this.errors.push(error);
      this.emitUpdate();
    }
  }]);
  return ConnectorController;
}();